// configuracion por defecto
// el JSON debe ser subido a s3://archivos.febos.io/cl/desarrollo/portales/portal.febos.cl.json
// donde portal.febos.cl se puede reemplazar por el dominio correspondiente

export default {
  moduloActual: '',
  inicio: [
    {
      url: { name: 'start' },
      name: 'Inicio',
      slug: 'start',
      icon: 'HomeIcon',
      permiso: '*'
    },
    {
      url: { name: 'super-board' },
      name: 'Super Tablero',
      slug: 'super-board',
      icon: 'CoffeeIcon',
      permiso: 'ED070'
    },
    {
      url: { name: 'board' },
      name: 'Mi Tablero',
      slug: 'board',
      icon: 'TrelloIcon',
      permiso: 'ED069'
    }
  ],
  menus: [
    {
      url: { name: 'start' },
      name: 'Inicio',
      slug: 'start',
      icon: 'HomeIcon',
      permiso: '*'
    },
    {
      url: { name: 'super-board' },
      name: 'Super Tablero',
      slug: 'super-board',
      icon: 'CoffeeIcon',
      permiso: 'ED070'
    },
    {
      url: { name: 'board' },
      name: 'Mi Tablero',
      slug: 'board',
      icon: 'TrelloIcon',
      permiso: 'ED069'
    }
  ]
};
